import React, { useCallback, useEffect, useMemo, useState } from 'react';

import $ from 'jquery';
import { v4 } from 'uuid';

import { format } from 'date-fns';
import {
  Container,
  Header,
  ItemsContainer,
  Item,
  ItemData,
  ResumeContainer,
  EmptyContainer,
} from './styles';

import { useCartCompany } from '../../../../hooks/cartCompany';
import { useProductsCompany } from '../../../../hooks/productsCompany';
import ICartProduct, {
  ICartProductPOS,
} from '../../../../interfaces/ICartProduct';
import { useAuth } from '~/hooks/auth';
import { useClients } from '~/hooks/clients';

import { updateInventoryOfProductsSold } from '~/utils/checkout/updateInventoryOfProductSold';

import { orderStatusRealtime } from '~/utils/checkout/orderStatusRealtime';
import { useToast } from '~/hooks/toast';
import { registerOrderInTable } from '~/utils/checkout/registerOrderInTable';
import { ORDER_TYPES_CONSTS } from '~/utils/getEnums';
import ITable from '~/interfaces/ITable';
import { useOrders } from '~/hooks/orders';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

import { handlePrint } from '../../../../utils/handlePrint';

const Cart: React.FC = () => {
  const {
    products,
    clear,
    increment,
    decrement,
    setProductCart,
    setShowOrderAddress,
    setShowConfirmOrder,
    updateDiscount,
    setAdditionValue: updateAdditionValue,
    tableSelected,
    setTableSelected,
  } = useCartCompany();
  const { selectProduct, products: products_list } = useProductsCompany();
  const { selectedClient } = useClients();
  const { company, user } = useAuth();
  const { addToast } = useToast();
  const { loadOrdersTable } = useOrders();

  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [additionValue, setAdditionValue] = useState(0);
  const [loading, setLoading] = useState(false);

  const parseProducts = useMemo(() => {
    const tmp: ICartProduct[] = [];

    products.forEach(item => {
      let total = 0;

      item.complements.forEach(element => {
        total += element.quantity * parseFloat(element.item.value);
      });

      tmp.push({
        ...item,
        image: item.image || '',
        value: `${parseFloat(item.value) + total}`,
      });
    });

    return tmp;
  }, [products]);

  const totalItems = useMemo(() => {
    let sum = 0;

    products.forEach(item => {
      sum += item.quantity;
    });

    return sum;
  }, [products]);

  const subtotal = useMemo(() => {
    let sum = 0;

    products.forEach(item => {
      sum += item.quantity * parseFloat(item.value);
    });

    return sum;
  }, [products]);

  const total = useMemo(() => {
    if (subtotal > 0) return subtotal - discountValue + additionValue;

    return 0;
  }, [subtotal, discountValue, additionValue]);

  const handleChangeDiscountPercentage = useCallback(
    event => {
      const discount = event.target.value
        ? (parseFloat(event.target.value) * subtotal) / 100
        : 0;

      setDiscountPercentage(parseFloat(event.target.value || 0));
      setDiscountValue(discount);

      let value_formatted = Number(discount).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      });

      value_formatted = value_formatted.replaceAll('R$', '');
      value_formatted = value_formatted.trim();

      $('#single_discount_value').val(value_formatted);

      setTimeout(() => {
        ($('.money') as any).mask('#.##0,00', { reverse: true });
      }, 100);
    },
    [subtotal],
  );

  const handleChangeAdditionValue = useCallback(() => {
    let addition = $('#addition_value').val() as string;
    let parseAddition = 0;

    if (addition) {
      addition = addition.replaceAll('.', '');
      addition = addition.replaceAll(',', '.');
      parseAddition = parseFloat(addition);

      setAdditionValue(parseAddition);
    }
  }, []);

  const handleChangeDiscountValue = useCallback(() => {
    let discount = $('#single_discount_value').val() as string;
    let parseDiscount = 0;

    if (discount) {
      discount = discount.replaceAll('.', '');
      discount = discount.replaceAll(',', '.');
      parseDiscount = parseFloat(discount);

      setDiscountValue(parseDiscount);

      const percentual = (parseDiscount * 100) / subtotal;
      setDiscountPercentage(percentual);
      $('#single_discount_percentual').val(percentual.toFixed());
    } else {
      setDiscountValue(0);
      setDiscountPercentage(0);
      $('#single_discount_percentual').val(0);
    }
  }, [subtotal]);

  const handleClickProductCart = useCallback(
    (selected: ICartProductPOS) => {
      setProductCart(selected);

      const find = products_list.find(item => item.uid === selected.uid);
      if (find) selectProduct(find);
    },
    [products_list, selectProduct, setProductCart],
  );

  const handlePrintCustom = useCallback(
    (order: IOrder) => {
      const parseOrder = {
        ...order,
        created_at_formatted: format(
          new Date(order.created_at),
          'dd/MM/yyyy HH:mm',
        ),
        additionValue_formatted:
          order.additionValue && order.additionValue > 0
            ? getCurrencyFormatted(order.additionValue)
            : '',
      };

      if (parseOrder.table?.uid) {
        handlePrint({ order: parseOrder, company, cozinha: true });
      } else {
        handlePrint({ order: parseOrder, company });
      }
    },
    [company],
  );

  const finishOrderTable = useCallback(async () => {
    try {
      setLoading(true);

      const uid = v4();
      const code = `${uid.substr(0, 3)}${uid.substr(uid.length - 3, 3)}`;
      const address = {};

      const parseData: any = {
        products: parseProducts,
        client_id: selectedClient.uid || '',
        shippingCost: 0,
        subtotal,
        subtotal_formatted: getCurrencyFormatted(subtotal),
        total,
        additionValue,
        address,
        company_id: company.uid,
        company_name: company.fantasy,
        company_user_id: company.user_id,
        created_at: new Date(),
        code,
        status: '0',
        pix_file: '',
        name: 'ATENDIMENTO BALCÃO',
        whatsapp: '',
        paymentMethod: '',
        thing: '',
        uid,
        order_type: ORDER_TYPES_CONSTS.TABLE,
        table: tableSelected,
      };

      // não registrar os pedidos de mesa para quando lançar o pagamento no fechamento da mesa
      // não contabilizar os pedidos 2 vezes
      // await setDoc(doc(DB, 'orders', uid), parseData);

      await registerOrderInTable({
        parseData,
        table: tableSelected,
        waiter_name: user.name,
      });
      await updateInventoryOfProductsSold(products);
      await loadOrdersTable();

      if (company.print_table_orders === '1') {
        handlePrintCustom({
          ...parseData,
          table: tableSelected,
          waiter_name: user.name,
        });
      }

      setTableSelected({} as ITable);
      $('#select-table').val('');
      // $("#myid option:selected").prop("selected", false)

      /**
       * Os pedidos de mesa não devem mais notificar, pois só será gerado um pedido no fechamento
       * da mesa
       */
      // notify({
      //   name: parseData.name,
      //   orderTotal: parseData.total,
      //   order_id: uid,
      //   company,
      // });

      orderStatusRealtime({ order_id: uid, user_id: user.uid });
      // updateReport();
      clear();

      addToast({
        type: 'success',
        description: 'Pedido realizado com sucesso.',
      });

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }, [
    setTableSelected,
    products,
    user,
    parseProducts,
    subtotal,
    clear,
    total,
    company,
    selectedClient,
    additionValue,
    addToast,
    tableSelected,
    loadOrdersTable,
    handlePrintCustom,
  ]);

  /**
   * Se especificar cliente -> delivery
   * Se nao especificar cliente abre modal para selecionar endereço
   */

  const handleSubmit = useCallback(() => {
    updateAdditionValue(additionValue);
    updateDiscount(discountValue, discountPercentage);

    if (tableSelected.uid) {
      finishOrderTable();
      return;
    }

    setShowOrderAddress(true);

    // setShowConfirmOrder(true);
  }, [
    setShowOrderAddress,
    // setShowConfirmOrder,
    updateDiscount,
    discountValue,
    discountPercentage,
    additionValue,
    updateAdditionValue,
    finishOrderTable,
    tableSelected,
  ]);

  useEffect(() => {
    ($('.money') as any).mask('#.##0,00', { reverse: true });
  }, []);

  return (
    <>
      <Container>
        {products.length > 0 && (
          <Header>
            <p />
            <span>{`${totalItems} itens`}</span>
          </Header>
        )}

        {products.length === 0 && (
          <EmptyContainer style={{ display: 'flex' }}>
            <i className="bx bx-cart" />
            <p>CARRINHO VAZIO</p>
          </EmptyContainer>
        )}

        {products.length > 0 && (
          <ItemsContainer>
            {products.map(item => (
              <Item key={item.id}>
                <ItemData onClick={() => handleClickProductCart(item)}>
                  {item.image && <img src={item.image} alt="Ilustracao" />}

                  <div>
                    <p>
                      <strong>{item.name}</strong>
                    </p>
                    <span>
                      <strong>
                        {Number(item.value).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </strong>
                    </span>
                    <section>
                      {item.complements.map(complement => (
                        <p>
                          {`${complement.quantity}x -${complement.item.name}`}
                          {parseFloat(complement.item.value) > 0 && (
                            <span>
                              {' - '}
                              {Number(complement.item.value).toLocaleString(
                                'pt-br',
                                {
                                  style: 'currency',
                                  currency: 'BRL',
                                },
                              )}
                            </span>
                          )}
                        </p>
                      ))}
                      {item.observations && (
                        <p>
                          Obs:
                          {item.observations}
                        </p>
                      )}
                    </section>
                  </div>
                </ItemData>

                <footer>
                  <button type="button" onClick={() => decrement(item.id)}>
                    <em className="icon ni ni-minus" />
                  </button>
                  <input type="text" value={item.quantity} />
                  <button type="button" onClick={() => increment(item.id)}>
                    <em className="icon ni ni-plus" />
                  </button>
                </footer>
              </Item>
            ))}
          </ItemsContainer>
        )}
      </Container>

      <ResumeContainer>
        <div className="d-flex">
          <div className="d-flex flex-column" style={{ marginRight: 8 }}>
            <label className="mb-0" style={{ fontSize: 12 }}>
              <strong>Desconto:</strong>
            </label>

            <div className="d-flex align-items-center">
              <div className="border rounded d-flex align-items-center p-1 mr-2">
                <label
                  htmlFor="single_discount_value"
                  className="mr-1 mb-0 text-nowrap"
                  style={{ fontSize: 12 }}
                >
                  R$
                </label>
                <input
                  id="single_discount_value"
                  type="text"
                  className="w-100 money"
                  onKeyUp={handleChangeDiscountValue}
                  disabled={subtotal === 0}
                />
              </div>

              <div className="border rounded d-flex align-items-center p-1">
                <input
                  id="single_discount_percentual"
                  type="number"
                  className="w-100"
                  onChange={handleChangeDiscountPercentage}
                  disabled={subtotal === 0}
                />
                <label
                  htmlFor="single_discount_percentual"
                  className="ml-1 mb-0 text-nowrap"
                  style={{ fontSize: 12 }}
                >
                  %
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column">
            <label className="mb-0" style={{ fontSize: 12 }}>
              <strong>Acréscimo:</strong>
            </label>

            <div className="border rounded d-flex align-items-center p-1">
              <label
                htmlFor="addition_value"
                className="mr-1 mb-0 text-nowrap"
                style={{ fontSize: 12 }}
              >
                R$
              </label>
              <input
                id="addition_value"
                type="text"
                className="w-100 money"
                onKeyUp={handleChangeAdditionValue}
                disabled={subtotal === 0}
              />
            </div>
          </div>
        </div>

        <div>
          <h3>Total</h3>
          <h3>
            {total.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </h3>
        </div>

        <button
          type="button"
          onClick={handleSubmit}
          disabled={products.length === 0}
        >
          {!loading && 'Fechar Pedido'}
          {loading && (
            <div className="spinner-border spinner-border-sm" role="status" />
          )}
        </button>
      </ResumeContainer>
    </>
  );
};

export default Cart;
